/* eslint-disable */
import {defineRule, configure} from "vee-validate";
import {
    required, min, max, confirmed, min_value, max_value, is, regex,
} from "@vee-validate/rules";
import {localize} from "@vee-validate/i18n";
import {messagesEN} from "@/messages/messages_en";

defineRule("required", required);
defineRule("min", min);
defineRule("max", max);
defineRule("min_value", min_value);
defineRule("max_value", max_value);
defineRule("confirmed", confirmed);
defineRule("is", is);
defineRule("regex", regex);

/*
 * Sprawdza czy hasło spełnia warunki:
 * Minimum jedna duża litera
 * Minimum jedna mała litera
 * Minimum jedna cyfra
 * Minimum jeden znak specjalny
 * Minimum 8 znaków
 */
defineRule("validPassword", (value) => {
    if (!value || !value.length) {
        return false;
    }

    let regexExp = new RegExp("^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()\\[\\]{};:+=|,<.>\\`~£§?/'\\-\\_\"])(?=.*[a-zA-Z]).{8,}$");

    if (!regexExp.test(value)) {
        return false;
    }

    return true;
});

defineRule("confirmed", (value, [other, label]) => {
    if (value !== other) {
        return `${label} ` + messagesEN.validations.notTheSame;
    }

    return true;
});

defineRule("email", value => {
    // Field is empty, should pass
    if (!value || !value.length) {
        return true;
    }

    // Check if email
    if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
        return false;
    }

    return true;
});

defineRule("isBefore", (value, [other]) => {
    const compareValue = typeof other === 'function' ? other() : other;

    if (!value || !compareValue) return true;

    // Method to parse Date compare them
    const parseDate = (str) => {
        const [day, month, year] = str.split('-');
        return new Date(`${year}-${month}-${day}`); // now ISO-compatible
    };

    const dateValue = parseDate(value);
    const dateOther = parseDate(compareValue);

    if (isNaN(dateValue.getTime()) || isNaN(dateOther.getTime())) {
        return 'Invalid date';
    }

    return dateValue < dateOther
        ? 'Last date must be after or equal to first date'
        : true;
});

configure({
    generateMessage: localize("en", {
        messages: messagesEN.validations,
    }),
});
